module.exports = __webpack_public_path__ + "img/correct_part_3_right.c5031347.png";